import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import promiseMiddleware from 'redux-promise';
import thunk from 'redux-thunk';

import { routerReducer, routerMiddleware } from 'react-router-redux';
import { firebaseAuthReducer, createFirebaseAuthMiddleware } from './modules/firebase/authModule';
import { firebaseDbReducer, createFirebaseDbMiddleware } from './modules/firebase/databaseModule';
import visualReducer from './reducers/visualReducer';

import { firebase } from '../utils/firebase';

const reducer = combineReducers({
    user: firebaseAuthReducer,
    visual: visualReducer,
    routing: routerReducer,
    firebase: firebaseDbReducer,
});

export default history => {
    const middleware = applyMiddleware(
        routerMiddleware(history),
        thunk,
        promiseMiddleware,
        createFirebaseAuthMiddleware(firebase),
        createFirebaseDbMiddleware(firebase),
    );

    return createStore(
        reducer,
        compose(
            middleware,
            window.devToolsExtension ? window.devToolsExtension() : f => f,
        ),
    );
}



// WEBPACK FOOTER //
// ./src/redux/store.js